/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdGlobalAppsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalAppsSettings.tsx';
import { adminOauthCredentialsResource } from '@jira/router-resources__admin-oauth-credentials/src/adminOauthCredentialsResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { getNavigationSidebarGlobalSettingsResources } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { settingsOauthCredentialsRoute } from '@jira/router-routes__settings-oauth-credentials-routes/src/settingsOauthCredentialsRoute.tsx';
import AdminOAuthCredentials, { LazyOAuthCredentialsAdmin } from './ui/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const settingsOauthCredentialsRouteEntry: Route = createEntry(
	settingsOauthCredentialsRoute,
	() => ({
		group: 'global-settings',
		// eslint-disable-next-line no-restricted-syntax
		component: AdminOAuthCredentials,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalAppsSettings,
			menuId: MenuIdProjects,
		},

		resources: [
			...getNavigationResources(),
			...getNavigationSidebarGlobalSettingsResources(),
			navigationSidebarGlobalResource,
			adminOauthCredentialsResource,
		],

		forPaint: [LazyAtlassianNavigation, LazyOAuthCredentialsAdmin],
		ufoName: 'admin.oauth-credentials',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
